import { render } from "./iron-mode-page.vue?vue&type=template&id=6e6a0171"
import script from "./iron-mode-page.vue?vue&type=script&lang=js"
export * from "./iron-mode-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__